import React from "react";

import { toUpperCaseNoAccent } from 'utils/stringHelper';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';


import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';


import Button from '@mui/material/Button';



const AddFraisRetourExcluDialog = ({ onClose, onClickSave, niveaux }) => {

    const [niveau, setNiveau] = React.useState(0);
    const [code, setCode] = React.useState('');
    const [profilPO, setProfilPO] = React.useState('N/A');
    

    const handleSetLevel = (level) => {

        let newLevel = niveaux.find(n => n.id === level);

        if (newLevel.libelle === 'ModeLivraisonProfil') {
            setProfilPO('');
        }
        else {
            setProfilPO('N/A');
        }
        setNiveau(level);
    };


    const save = () => {

        var fraisRetourExclu = {
            niveau: niveau,
            code: code,
            profilPO: profilPO
        };

        onClickSave(fraisRetourExclu);
        onClose();
    };

    return (
        <Dialog open>
            <DialogTitle>Nouvelle exclusion des frais de retour</DialogTitle>

            <DialogContent>

                <Stack spacing={2} mt={1}>

                    <TextField
                        id="niveau"
                        name="niveau"
                        label="Niveau"
                        required

                        select
                        SelectProps={{
                            required: true,
                            value: niveau,
                            onChange: e => handleSetLevel(e.target.value),
                        }}
                    >
                        {niveaux.map(n => <MenuItem key={n.id} value={n.id}>{n.libelle}</MenuItem>)}
                    </TextField>

                    <TextField
                        id="code"
                        name="code"
                        label="Code"
                        required
                        placeholder="Saisir un code"
                        value={code}
                        onChange={e => setCode(toUpperCaseNoAccent(e.target.value))}
                    />

                    <TextField
                        id="profilPO"
                        name="profilPO"
                        label="Profil PO"
                        placeholder="Saisir un profiPO"
                        value={profilPO}
                        onChange={e => setProfilPO(toUpperCaseNoAccent(e.target.value))}
                        disabled={niveaux.find(n => n.id === niveau).libelle !== 'ModeLivraisonProfil'}
                        required={niveaux.find(n => n.id === niveau).libelle === 'ModeLivraisonProfil'}
                    />

                </Stack>
                

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={save}
                    variant="contained"
                    color="secondary"
                    disabled={!code || !profilPO}
                >
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default AddFraisRetourExcluDialog;
